module.exports = __webpack_public_path__ + "static/media/undraw-timeline-9-u-4-u.638b8ab1.svg";